export default {
  manageWeekendDeliveryCardTitle: {
    id: 'bo_seller.options.shipping.weekend_delivery_card.title',
    defaultMessage: 'Manage weekend delivery',
  },
  manageWeekendDeliveryCardDescription: {
    id: 'bo_seller.options.shipping.weekend_delivery_card.description',
    defaultMessage:
      'Improve delivery estimates and reach your customers faster with weekend delivery.',
  },
  manageWeekendDeliveryCardDrawerTriggerManage: {
    id: 'bo_seller.options.shipping.weekend_delivery_card.drawer.trigger.manage',
    defaultMessage: 'Manage weekend deliveries',
  },
  manageWeekendDeliveryCardDrawerCloseButton: {
    id: 'bo_seller.options.shipping.weekend_delivery_card.drawer.close_button',
    defaultMessage: 'Close',
  },
  manageWeekendDeliveryCardDrawerTitle: {
    id: 'bo_seller.options.shipping.weekend_delivery_card.drawer.title',
    defaultMessage: 'Weekend delivery',
  },
  manageWeekendDeliveryCardDrawerSubmitButton: {
    id: 'bo_seller.options.shipping.weekend_delivery_card.drawer.submit_button',
    defaultMessage: 'Save changes',
  },
  manageWeekendDeliveryGetConfigurationErrorTitle: {
    id: 'bo_seller.options.shipping.weekend_delivery.get_configuration.error.title',
    defaultMessage: 'Something went wrong',
  },
  manageWeekendDeliveryGetConfigurationErrorContent: {
    id: 'bo_seller.options.shipping.weekend_delivery.get_configuration.error.content',
    defaultMessage:
      'We couldn’t retrieve your weekend delivery configuration. Please try again.',
  },
  manageWeekendDeliveryUpdateConfigurationSuccessTitle: {
    id: 'bo_seller.options.shipping.weekend_delivery.update_configuration.success.title',
    defaultMessage: 'Changes saved',
  },
  manageWeekendDeliveryUpdateConfigurationSuccessContent: {
    id: 'bo_seller.options.shipping.weekend_delivery.update_configuration.success.content',
    defaultMessage: 'Your weekend delivery changes have been updated.',
  },
  manageWeekendDeliveryUpdateConfigurationErrorTitle: {
    id: 'bo_seller.options.shipping.weekend_delivery.update_configuration.error.title',
    defaultMessage: 'Something went wrong',
  },
  manageWeekendDeliveryUpdateConfigurationErrorContent: {
    id: 'bo_seller.options.shipping.weekend_delivery.update_configuration.error.content',
    defaultMessage:
      'We couldn’t save your weekend delivery changes. Please try again.',
  },
  manageWeekendDeliveryTitle: {
    id: 'bo_seller.options.shipping.weekend_delivery.drawer.title',
    defaultMessage: 'Weekend delivery',
  },
}
